import React from 'react';
import {
    SimpleTable,
    MasterLayoutMiddle,
    FooterInner
} from '@dclab/dc-react-ui-kit';

import Edit from "../../../assets/img/create-24px.svg";
import Delete from "../../../assets/img/delete_forever-24px.svg";
import { useHistory } from 'react-router-dom';
import INSTRUCTOR from '../../../assets/img/Ellipse_1.png';

function Instructors(props) {

    const style = {
        width: '100%',
    };

    const history = useHistory();

    // ============================== Table Start ======================================//
    let col = [

        { type: 'link', name: 'invoice_number', label: 'IMAGE', width: '0%' },
        { type: 'string', name: 'date', label: 'INSTRUCTOR NAME', width: '40%' },
        { type: 'string', name: 'date', label: 'DESIGNATION', width: '40%' },
        { type: 'string', name: 'date', label: '', width: '20%' },
        { type: 'action', label: 'ACTION', width: '10%' }

    ];

    const selected_categories = col.sort((a, b) => a.order - b.order)
    let rows = selected_categories.map((text, index) => {
        let i = index + 1
        return (
            [
                { name: 'textImg', type: 'string', src: INSTRUCTOR, },
                { type: 'string', name: 'name', value: 'Abdul Al Razi' },
                { type: 'status', name: 'string', value: 'Khatib BIC' },
                { type: 'string', name: 'amount', value: '' },

            ]
        )
    })


    // ============================== Table End ======================================//

    return (


        <MasterLayoutMiddle

            content={
                <div className="table_box">
                    <SimpleTable
                        showHeader={true}
                        title="Instructors"
                        width="100%"
                        rows={rows}
                        columns={col}
                        colSpan={16}
                        actionSendButton={true}
                        donationsCount={rows && rows.length > 0 ? 1 : 0}
                        noTitle="No inquiry submitted yet"
                        noPara="Inquiries submitted by visitors will be visible and managed here."
                        noBtnText=""
                        onInviteClick={() =>
                            props.history.push(
                                "/education/add-attendance"
                            )
                        }
                        actionLink={(name) => props.history.push({ pathname: "/education/instructors/add-new-instructors", state: { contact: name[0].data } })}
                        deleteAction={(e) => console.log(e)}
                        showFooter={true}
                        showIconCol={true}
                        editIcon={Edit}
                        deleteIcon={Delete}
                        showAdd={true}
                        onAddClick={() => history.push("/education/instructors/add-new-instructors")}
                        addText='ADD NEW'

                    />
                </div>
            }
            isFooter={true}
            footer={
                <FooterInner
                    style={style}
                    termsLink={process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies" : "http://deenconnect.io/terms-policies"}
                    privacyLink={process.env.REACT_APP_Environment === 'dev' ? "http://shapla.deenconnect.io/terms-policies#privacy-policy" : "http://deenconnect.io/terms-policies#privacy-policy"}
                />
            }
            isWhiteBackground={false}
        />



    );
}


export default Instructors;